import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';

const SAccordion = styled(Accordion)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 34px;
  color: ${props => props.theme.secondaryColor};
`;

const HalfWidth = styled.div`
  flex-basis: 50%;
`;

const SCard = styled(Card)`
  margin-bottom: 33px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const SHeader = styled(Card.Header)`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;

  &:after {
    content: "\\25e2";
    font-size: 7px;
    margin-left: 6px;
  }

  &.expanded:after {
    content: "\\25e5";
  }
`;

const SCollapse = styled(Accordion.Collapse)`
  &:not(.show) {
    display: none;
  }
`;

const SBody = styled(Card.Body)`
  display: flex;
  flex-direction: column;
  margin-top: 6px;
`;

const Link = styled.a`
  color: ${props => props.theme.secondaryColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 14px;
  margin: 33px 0 5px 0;
`;

export default function SiteMapMobile(props) {
  const { siteMap } = props;
  const [opened, setOpened] = React.useState(-1);

  /* eslint-disable react/prop-types */
  const buildCard = offset => ({ name, sections }, i) => {
    const j = i + offset;
    return (
      <SCard key={name}>
        <Accordion.Toggle
          as={SHeader}
          eventKey={j}
          onClick={() => setOpened(opened === j ? -1 : j)}
          className={classNames({ expanded: opened === j })}
        >
          {name}
        </Accordion.Toggle>
        <SCollapse eventKey={j}>
          <SBody>
            {sections.map(s => <Link key={s.name} href={s.url}>{s.name}</Link>)}
          </SBody>
        </SCollapse>
      </SCard>
    );
  };
  /* eslint-enable react/prop-types */

  const half = siteMap.length / 2;

  return (
    <SAccordion>
      <HalfWidth>{_.take(siteMap, half).map(buildCard(0))}</HalfWidth>
      <HalfWidth>{_.takeRight(siteMap, siteMap.length - half).map(buildCard(half))}</HalfWidth>
    </SAccordion>
  );
}

SiteMapMobile.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  })).isRequired,
};
